// utils/createDictionary.ts
import { EventName } from '@/constants';
import i18n from '@/plugins/i18n';
import eventBus from '@/services/eventBus';
import { ISimpleDictionaryItem } from '@/types';

export function createSimpleDictionary<T extends ISimpleDictionaryItem>(items: T[], translatedFields: (keyof T)[] = ['name', 'shortName']) {
    const dictionary = {
        items: [] as T[],
        _map: {} as Record<number | string, string>,
        _cacheItems: {} as Record<number | string, T>,
        nameById(id: number | string): string {
            return this._map[id];
        },
        itemById(id: number | string): T {
            return this._cacheItems[id];
        },
        filterBy(filters: Partial<T>): T[] {
            const fields = Object.keys(filters) as (keyof T)[];

            return this.items.filter((item) => fields.every((field) => item[field] === filters[field]));
        },
        update() {
            const t = i18n.global.t;
            dictionary._map = {};
            dictionary._cacheItems = {};
            dictionary.items = [];
            /*for (let i = 0; i < items.length; i++) {
                const translatedName = t(items[i].name);
                dictionary._map[items[i].id] = translatedName;
                dictionary.items[i] = { ...items[i], name: translatedName };
            }*/
            dictionary.items = items.map((item) => {
                const translatedItem = { ...item };

                for (const field of translatedFields) {
                    const value = item[field];
                    if (typeof value === 'string' && value) {
                        translatedItem[field] = t(value) as any;
                    }
                }

                dictionary._map[item.id] = translatedItem.name;
                dictionary._cacheItems[item.id] = translatedItem;
                return translatedItem;
            });
        },
    };

    dictionary.update();

    eventBus.on(EventName.LanguageChanged, dictionary.update);

    return dictionary;
}
